import { render, staticRenderFns } from "./baseFormComponent.vue?vue&type=template&id=ce5b4828&scoped=true"
import script from "./baseFormComponent.vue?vue&type=script&lang=ts"
export * from "./baseFormComponent.vue?vue&type=script&lang=ts"
import style0 from "./baseFormComponent.vue?vue&type=style&index=0&id=ce5b4828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5b4828",
  null
  
)

export default component.exports